export var FlightState;
(function (FlightState) {
    FlightState["NotSet"] = "NotSet";
    FlightState["Running"] = "Running";
    FlightState["Stopped"] = "Stopped";
})(FlightState || (FlightState = {}));

//# sourceMappingURL=FlightModels.js.map
